var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33268 13.5352C2.32769 12.8625 1.66602 11.7168 1.66602 10.4167C1.66602 8.46367 3.15894 6.85941 5.0658 6.68281C5.45586 4.31011 7.51622 2.5 9.99935 2.5C12.4825 2.5 14.5428 4.31011 14.9329 6.68281C16.8398 6.85941 18.3327 8.46367 18.3327 10.4167C18.3327 11.7168 17.671 12.8625 16.666 13.5352M6.66602 13.3333L9.99935 10M9.99935 10L13.3327 13.3333M9.99935 10V17.5",
    stroke: "#3A3A3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.17230ec84664be7b96aa2a1f8a6dbf07.svg";
export { ForwardRef as ReactComponent };